let $ = jQuery;
let Hammer = require('hammerjs');
let breakpoints = require('../utilities/breakpoints');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

class EventsCalendar {

  constructor($calendar) {
    this.$calendar = $calendar;
    this.$navBtns = $calendar.find('.js-calendar-btn');
    this.$calendarContent = $calendar.find('.events-calendar__upcoming');
    this.$calendarItems = this.$calendarContent.find('.events-calendar__item');
    this.$calendarLinks = this.$calendarItems.find('.cta-link');
    this.activeIndex = 0;
    this.isAnim = false;

    this.currBreakpoint = breakpoints.current;

    $(window).resize(() => this.handleState()).trigger('resize');

    this.bindEvents();
  }

  bindEvents() {
    if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {
      this.bindSwipeEvents();
      this.bindClickEvents();
      this.bindFocus();
    }
  }

  bindFocus() {
    this.$calendarLinks.focus((e) => this.handleFocus(e));
  }

  handleFocus(e) {
    let $target = $(e.currentTarget);
    let $calendarItem = $target.parents('.events-calendar__item');
    let index = this.$calendarItems.index($calendarItem);

    let featuredItem = this.$calendar.find('.events-calendar__item--featured');
    let contentVisWidth = this.$calendar.outerWidth() - featuredItem.outerWidth();
    let itemWidth = this.$calendarItems.outerWidth();
    let possibleVisItems = Math.floor(contentVisWidth / itemWidth);

    if (index >= this.activeIndex + possibleVisItems) {
      this.moveCalendar('next');
    }
    else if (index <= this.activeIndex - 1) {
      this.moveCalendar('previous');
    }


  }

  bindClickEvents() {
    $('.js-calendar-btn').off('click.evtCalBtn').on('click.evtCalBtn', (e) => this.handleClick(e));
  }

  bindSwipeEvents() {
    let content = this.$calendarContent[0];
    let hammer = new Hammer(content);
    hammer.on('swipeleft', () => this.moveCalendar('next'));
    hammer.on('swiperight', () => this.moveCalendar('previous'));
  }

  moveCalendar(direction, index) {
    let offset;

    if (
      this.isAnim
      || (direction === 'next' && !this.canMoveRight())
      || (direction === 'previous' && !this.canMoveLeft())
    ) {
      return false;
    }

    this.isAnim = true;

    if (direction === 'next') {
      this.activeIndex++;
    }
    else {
      this.activeIndex--;
    }

    window.TweenLite.to(this.$calendarContent, 0.25, {
      left: '-' + this.getOffset(direction),
      onComplete: () => {
        this.isAnim = false;
      }
    });
  }

  getOffset(direction) {
    let offset;
    let featuredItem = this.$calendar.find('.events-calendar__item--featured');
    let contentVisWidth = this.$calendar.outerWidth() - featuredItem.outerWidth();
    let itemWidth = this.$calendarItems.outerWidth();
    let possibleVisItems = Math.floor(contentVisWidth / itemWidth);


    if (this.activeIndex === this.$calendarItems.length - possibleVisItems) {
      offset = (itemWidth * this.activeIndex) - (contentVisWidth % itemWidth);
    }
    else {
      offset = itemWidth * this.activeIndex;
    }

    return offset;
  }

  canMoveRight() {
    let featuredItem = this.$calendar.find('.events-calendar__item--featured');
    let contentVisWidth = this.$calendar.outerWidth() - featuredItem.outerWidth();
    let possibleVisItems = Math.floor(contentVisWidth / this.$calendarItems.outerWidth());

    return this.activeIndex < this.$calendarItems.length - possibleVisItems;
  }

  canMoveLeft() {
    return this.activeIndex > 0;
  }

  handleClick(e) {
    let $target = $(e.currentTarget);
    let dir = $target.hasClass('events-calendar__previous') ? 'previous' : 'next';

    this.moveCalendar(dir);

    return false;
  }

  handleState() {

    if (this.currBreakpoint !== breakpoints.current) {
      this.$calendarContent.css('left', '0px');
      this.bindEvents();
      this.currBreakpoint = breakpoints.current;
    }
  }

}

module.exports = {
  attach: function(context, settings) {

    let $calendars = $('.js-events-calendar');
    let calendarsArr = [];

    $calendars.each((index) => {
      let $calendar = $calendars.eq(index);
      calendarsArr.push(new EventsCalendar($calendar));
    });
  }
}
